import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { HistoryMovement } from 'types';

import TableBody from 'modules/_shared/Table/components/TableBody';

import { useHistoryMovementsView } from '../../context/HistoryMovementsViewContext';
import RenumerationTableRow from './RenumerationTableRow';

const RenumerationTableBody: FC = () => {
  const { t } = useTranslate();
  const { data } = useHistoryMovementsView();

  const hasData = data.historyMovements?.length > 0;

  const rows = data.historyMovements!.map(
    (movement: HistoryMovement, index: number) => (
      <RenumerationTableRow
        // eslint-disable-next-line react/no-array-index-key
        key={`movement-row-${index}`}
        index={index}
        movement={movement}
      />
    )
  );

  return <TableBody hasData={hasData} content={rows} noDataMessage={t('')} />;
};

export default RenumerationTableBody;
